import { InjectedTypes } from "types/injector";
import ArticleInjector from "components/ads/ArticleInjector";
import ArticleRelatedContentModule from "components/article/ArticleRelatedContentModule";
import ArticleRelatedContentMagazine from "components/article/ArticleRelatedContentMagazine";
import ArticleBooksModule from "components/article/ArticleBooksModule";
import Native from "components/ads/Native";
import HousePromo from "components/ads/HousePromo";
import { ArticleRelatedContentType } from "types/api";

/**
 * Return a React Component based on the InjectedType
 * @param type InjectedTypes
 * @return React.Component
 */
const getInjectedComponent = (
  type: InjectedTypes,
  num: number,
  runCount: number,
  articleId: string
): JSX.Element => {
  const key = `inject-${runCount}`;
  switch (type) {
    case InjectedTypes.Ad:
      return (
        <ArticleInjector key={`${key}-${num}`} targetingPos={`csi-ad-${num}`} />
      );
    case InjectedTypes.Native:
      return <Native key={`${key}-${num}`} />;
    case InjectedTypes.House:
      // Prepopulate a prop
      return <HousePromo isSwan={true} key={`${key}-${num}`} />;
    case InjectedTypes.Recirc:
      return (
        <ArticleRelatedContentModule
          key={`${key}-${num}`}
          __typename="ArticleRelatedContentModule"
          contentType={ArticleRelatedContentType.Curated}
          count={1}
        />
      );
    case InjectedTypes.Books:
      return <ArticleBooksModule key={`${key}-${num}`} />;
    case InjectedTypes.MagPromo:
      return (
        <ArticleRelatedContentMagazine id={articleId} key={`${key}-${num}`} />
      );
  }

  const EmptyElement = () => <div></div>;
  return <EmptyElement key={`${key}-${num}`} />;
};
export default getInjectedComponent;
